module.exports = __webpack_public_path__ + "img/37435ca8c40cc1599625923bf16be565.png";